import requestModule from '@/application/libs/requestModule'
import eventModule from '@/application/libs/eventModule'
import Util from '@/application/libs/util'
import moment from 'moment'
import { t } from 'i18next'

export default {
    /**
     * Save initial parametrized data into
     * local storage to be used in entire system.
     * 
     * @param {Object} form 
     */
    saveParams(form, vueNode){
        if(this.validateForm(form)){
            let boData = Util.getFilterInSession();
            let oldBoData = {...boData};
            
            boData.CDFILIAL = form.unit.CDFILIAL;
            boData.NMFILIAL = form.unit.NMFILIAL;
            
            boData.CDSERVFILI = form.service.CDSERVFILI;
            boData.NMSERVICO = form.service.NMSERVICO;
            
            boData.TPCONTRATO = form.contract.contractType;
            boData.NMCONTRATO = form.contract.contractName;

            boData.DTMESCARD = moment(form.date, 'YYYY-MM').startOf('month').format('DD/MM/YYYY');
            Util.setLocalVar('backOfficeData', boData);
            sessionStorage.setItem('filterData', JSON.stringify(boData));
            
            Util.showSuccessNotification({
                title: t('saved_data'),
                text: t('parameterized_data')
            });

			vueNode.$emit('close');
			eventModule.$emit('updateBoData', {oldValue: oldBoData, newValue: boData});
        } else {
            Util.showErrorNotification({
                title: t('error_saving'),
                text: t('fill_in_all_fields')
            });
        }
    },
    
    /**
     * Validate if all fields are filled
     * 
     * @param {Object} form 
     * 
     * @returns {Boolean}
     */
    validateForm(form){
        return (form.unit && form.unit.CDFILIAL &&
            form.service && form.service.CDSERVFILI &&
            form.contract && form.contract.contractType &&
            form.date);
    },

    /**
     * Get unit data and set it on modal
     * form
     * 
     * @param {Object} form 
     */
    getUnitData(form){
        requestModule.postRequest('getData', {
            FROM: "FILIAL",
            PARAMS: {
                CDOPERADOR: Util.getLocalVar('userData').CDOPERADOR
            }
        }).then(response=>{
            if(response.dataset && response.dataset.data){
                form.unitOptions = response.dataset.data;
            }
        });
    },

    /**
     * Get service data and set it on modal
     * form
     * 
     * @param {Object} form 
     */
    getServiceData(form){
        requestModule.postRequest('getData', {
            FROM: "SERVICOS",
            PARAMS: {
                CDFILIAL: form.unit.CDFILIAL
            }
        }).then(response=>{
            if(response.dataset && response.dataset.data){
                form.serviceOptions = response.dataset.data;
            }
        });
    },
}